import React from "react";
import { nils, trim_addr, dec } from "../../utils/utils.jsx";
import { useSkinsMasterContext } from "./SkinsMaster.jsx";
import { TokenIcon } from "../../components/utilityComps.jsx";

export const ProfileRow = () => {
  const { _profile, _bal } = useSkinsMasterContext();

  // Don't show if profile is empty
  if (nils(_profile) || nils(_profile.vault)) {
    return null;
  }

  const { vault, vault_name, name, profile_url, banner_url } = _profile;
  const {
    balances,
    balances_usd,
    loading: balLoading,
    error: balError,
  } = _bal || {};

  return (
    <div className="mb-8 md:mb-12">
      <div className="bg-slate-800/40 border border-slate-600/50 backdrop-blur-sm rounded-2xl p-6 relative overflow-hidden">
        {/* Banner Background */}
        {banner_url && (
          <div
            className="absolute inset-0 bg-cover bg-center opacity-10 grayscale blur-sm"
            style={{ backgroundImage: `url(${banner_url})` }}
          />
        )}

        <div className="relative z-10">
          {/* Top Row: Profile Image + Info */}
          <div className="flex items-center space-x-4 mb-4 lg:mb-0">
            {/* Profile Image */}
            <div className="flex-shrink-0">
              {profile_url ? (
                <img
                  src={profile_url}
                  alt={name || vault_name || "Profile"}
                  className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full border-2 border-r3lig/50 object-cover"
                />
              ) : (
                <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-r3lig/20 border-2 border-r3lig/50 flex items-center justify-center">
                  <span className="text-r3lig font-digi text-base sm:text-lg">
                    {(name || vault_name || vault)?.charAt(0)?.toUpperCase()}
                  </span>
                </div>
              )}
            </div>

            {/* Profile Info */}
            <div className="flex-grow">
              <h2 className="text-lg sm:text-xl md:text-2xl font-digi text-white mb-1">
                {name || vault_name || "Unnamed Vault"}
              </h2>
              <p className="text-gray-400 text-xs sm:text-sm font-mono">
                {trim_addr(vault)}
              </p>
            </div>
          </div>

          {/* Token Balances - Separate row on mobile, inline on desktop */}
          <div className="lg:absolute lg:right-6 lg:top-1/2 lg:-translate-y-1/2">
            {balLoading ? (
              <div className="text-gray-400 text-sm text-center lg:text-right">Loading balances...</div>
            ) : balError ? (
              <div className="text-red-400 text-sm text-center lg:text-right">Balance error</div>
            ) : balances ? (
              <div className="grid grid-cols-3 gap-3 sm:gap-4 md:gap-6 text-center lg:text-right">
                <div>
                  <div className="flex items-center justify-center lg:justify-end space-x-1 mb-1">
                    <TokenIcon token="DEZ" size="xs" className="" />
                    <span className="text-xs text-cyan-400 font-digi">DEZ</span>
                  </div>
                  <div className="text-xs sm:text-sm font-bold text-cyan-400">
                    {dec(balances.DEZ, 2)}
                  </div>
                  {balances_usd?.DEZ > 0 && (
                    <div className="text-[10px] sm:text-xs text-cyan-300">
                      ${dec(balances_usd.DEZ, 2)}
                    </div>
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-center lg:justify-end space-x-1 mb-1">
                    <TokenIcon token="WETH" size="xs" className="" />
                    <span className="text-xs text-pink-400 font-digi">
                      WETH
                    </span>
                  </div>
                  <div className="text-xs sm:text-sm font-bold text-pink-400">
                    {dec(balances.WETH, 4)}
                  </div>
                  {balances_usd?.WETH > 0 && (
                    <div className="text-[10px] sm:text-xs text-pink-300">
                      ${dec(balances_usd.WETH, 2)}
                    </div>
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-center lg:justify-end space-x-1 mb-1">
                    <TokenIcon token="SGC" size="xs" className="" />
                    <span className="text-xs text-yellow-400 font-digi">SGC</span>
                  </div>
                  <div className="text-xs sm:text-sm font-bold text-yellow-400">
                    {dec(balances.SGC, 0)}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

